import * as service from './medicals.services'
export default {
  data() {
    return {

      currentuseremail: '',
      personaldetails: [],
      iseditable: true,
      // imgSrc: '',
      // suitsize: [],
      fileImg: '',
      personalForm: {


        MedicalCondition: '',
        MedicalNotes: '',
        Allergies: '',
        SpecialInstructions: '',

      },
      responseModel: {
        PersonnelId: '',
        MedicalCondition: '',
        Allergies: '',
        MedicalNotes: '',
        SpecialInstructions: ''
      }

    }
  },

  props: ['data', 'editShow'],
  watch: {

    data: function () {
      /*  alert(JSON.stringify(this.data))*/
      this.responseModel = {
        PersonnelId: this.data.response.PersonnelId,

        MedicalCondition: this.data.response.MedicalCondition,
        Allergies: this.data.response.Allergies,
        MedicalNotes: this.data.response.MedicalNotes,
        SpecialInstructions: this.data.response.SpecialInstructions
      }

      this.contBackup = deepcopy(this.responseModel)

      this.personalForm = this.contBackup




    }

  },

  mounted() {


  },

  methods: {
    modalCancel() {

      if ($('#PostsignupModel').length > 0) {
        $('#PostsignupModel').modal('hide')
      } else {

        this.personalForm = deepcopy(this.responseModel)

        this.data['isEdit'] = false

      }

    },
    backProfile() {
      this.$router.push('/addpersonnel')

    },

    cEdit() {
      debugger
      if (this.data["isEdit"] == true) {
        this.data["isEdit"] = false
      } else if (this.data["isEdit"] == false) {
        this.data["isEdit"] = true
      }

    },
    save(formName) {
      let context = this
      debugger

      var formdata = {
        PersonnelId: this.data.response.PersonnelId,
        MedicalCondition: context.personalForm.MedicalCondition,
        Allergies: context.personalForm.Allergies,
        MedicalNotes: context.personalForm.MedicalNotes,
        SpecialInstructions: context.personalForm.SpecialInstructions,

      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // var form_data = new FormData();



          loader.startLoader()

          service.UpdateMedicalConditions(formdata).then(function (response) {

            //context.$localStorage.set('authentication', JSON.stringify(authDetails))
            // context.personalForm = context.personalForm
            //FG - FOOF - AFTER CERT - First Release Security - seems the broadcast below is not needed
            //            AND when it is in place causes problems
            //context.$router.app.$emit('updatedinfo')

            context.data['isEdit'] = true
            context.$notify({

              title: 'Success',

              message: 'Medical Condition  Details Updated',

              type: 'success'

            })
            loader.stopLoader()

          }, (error) => {
            debugger
            context.data['isEdit'] = true
            context.personalForm = deepcopy(context.responseModel)
            context.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
            loader.stopLoader()

          })

        }
      })

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/MedicalConditions/medicals.controller.js